import { action } from 'typesafe-actions';

import { ProvinceAutoComplete } from 'models/provinceAutoComplete';

export const PROVINCES_AUTO_COMPLETE_REQUEST = 'PROVINCES_AUTOCOMPLETE_REQUEST';
export const PROVINCES_AUTO_COMPLETE_SUCCESSFUL = 'PROVINCES_AUTOCOMPLETE_SUCCESSFUL';
export const PROVINCES_AUTO_COMPLETE_FAILURE = 'PROVINCES_AUTOCOMPLETE_FAILURE';

export const provincesAutoCompleteRequest = () => action(PROVINCES_AUTO_COMPLETE_REQUEST);

export const provincesAutoCompleteSuccessful = (provinces: ProvinceAutoComplete[]) => action(PROVINCES_AUTO_COMPLETE_SUCCESSFUL, provinces);

export const provincesAutoCompleteError = (error: string) => action(PROVINCES_AUTO_COMPLETE_FAILURE, error);
